// fetch接口请求

import { fetch } from '@/common/request';
import { FunctionType, Role } from '@/pages/chat/type';
import { Key } from 'react';

export interface ProcessDefinitionList {
  id: FunctionType;
  agentId?: number; // 智能体 ID
  agentCode?: string; // 智能体编码
  agentName?: string; // 智能体名称
  agentDescription?: string; // 智能体描述
  enableThinking?: number; // 是否展示思考过程
  showInCard?: number; // 是否以卡片形式展示
  recordHistory?: number; // 是否记录历史
  recommendedQuestions?: string[]; // 默认推荐问题
}

export interface ConversationListReqVo {
  tenantMcid?: string;
  staffId?: string;
}

export interface ConversationListVo {
  id: number;
  conversationId: string;
  tenantMcid?: string;
  staffId?: number;
  agentId?: number;
  agentName?: string;
  conversationName: string;
  createdAt?: string;
  updatedAt?: string;
  nameGenerated?: boolean;
}

export interface MessageListReqVo {
  conversationId?: Key;
  tenantMcid?: string;
  staffId?: string;
}

export interface MessageListVo {
  id: Key;
  conversationName?: string;
  message?: string;
  role?: Role;
  createTime?: string;
  updateTime?: string;
}

export function getProcessDefinitionList(tenantMcid: string): Promise<ProcessDefinitionList[]> {
  return fetch(
    '/api/auth/tenant/authList',
    {
      method: 'POST',
      body: JSON.stringify({ tenantMcid }),
    },
    true,
  );
}

export interface ConversationRespVo {
  records?: ConversationListVo[];
  current: number;
  size: number;
  total: number;
}

export function getConversationList(params: ConversationListReqVo): Promise<ConversationRespVo> {
  const query = new URLSearchParams();
  if (params.tenantMcid) query.set('tenantMcid', params.tenantMcid);
  if (params.staffId) query.set('staffId', params.staffId);

  return fetch(
    `/api/agent/react/conversations${query.toString() ? `?${query.toString()}` : ''}`,
    {
      method: 'GET',
    },
    true,
  );
}

export function getMessagesList(params: MessageListReqVo): Promise<MessageListVo[]> {
  const query = new URLSearchParams();
  if (params.conversationId) query.set('conversationId', String(params.conversationId));
  if (params.tenantMcid) query.set('tenantMcid', params.tenantMcid);
  if (params.staffId) query.set('staffId', params.staffId);

  return fetch(
    `/api/agent/react/historyRaw${query.toString() ? `?${query.toString()}` : ''}`,
    {
      method: 'GET',
    },
    true,
  );
}

export function deleteConversation(id: number): Promise<void> {
  const query = new URLSearchParams();
  query.set('id', String(id));

  return fetch(
    `/api/agent/react/conversation/delete?${query.toString()}`,
    {
      method: 'POST',
    },
    true,
  );
}
